export const SuperwallLastApplicationIdKey = "superwall-last-application-id"
